import React from "react";
import { DocumentStatus, StatusBadge } from "../constants/DocStatus";

interface DynamicTableProps {
  data: Record<string, any>[];
  excludeKeys?: string[];
  showId?: boolean;
  showDateImport?: boolean;
  showStatus?: boolean;
  showIle?: boolean;
  showRegion?: boolean;
  showCommune?: boolean;
  showLocalite?: boolean;
}

const DEFAULT_EXCLUDES = [
  "id_crde",
  "id_groupe_import",
  "date_import",
  "id",
  "status",
  "id_ile",
  "id_region",
  "id_commune",
  "id_localite",
  "Ile",
  "Region",
  "Commune",
  "Localite"
];

const DynamicTable: React.FC<DynamicTableProps> = ({
  data,
  excludeKeys = [],
  showId = true,
  showDateImport = true,
  showStatus = true,
  showIle = true,
  showRegion = true,
  showCommune = true,
  showLocalite = true
}) => {
  if (!data || data.length === 0) {
    return <p style={{textAlign:"center"}}>Aucune donnée disponible</p>;
  }

  for (const item of data) {
    console.log(item, typeof item);
  }

  const finalExcludedKeys = new Set([
    ...DEFAULT_EXCLUDES,
    ...excludeKeys,
  ]);

  const columns = Object.keys(data[0]).filter(
    (key) => !finalExcludedKeys.has(key)
  );

  return (
    <div className="table-responsive">
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            {showId && <th>Id</th>}
            {showIle && <th>Île</th>}
            {showRegion && <th>Région</th>}
            {showCommune && <th>Commune</th>}
            {showLocalite && <th>Localité</th>}
            {columns.map((key) => (
              <th key={key}>{key}</th>
            ))}
            {showDateImport && <th>Date import</th>}
            {showStatus && <th>Statut</th>}
          </tr>
        </thead>

        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              {showId && <td>{item.id}</td>}
              {showIle && <td>{item.Ile || "-"}</td>}
              {showRegion && <td>{item.Region || "-"}</td>}
              {showCommune && <td>{item.Commune || "-"}</td>}
              {showLocalite && <td>{item.Localite || "-"}</td>}

              {columns.map((key) => (
                <td key={key}>
                  {String(item[key] ?? "")}
                </td>
              ))}

              {showDateImport && (
                <td>
                  {item.date_import
                    ? new Date(item.date_import).toLocaleDateString()
                    : ""}
                </td>
              )}

              {showStatus && (
                <td>
                  <StatusBadge statut={item.status as DocumentStatus} />
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DynamicTable;